import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Driver } from 'app/models/driver.model';
import { Role, User } from 'app/models/user.model';
import { DriverService } from 'app/services/driver/driver.service';
import { UserService } from 'app/services/users/user.service';
declare const swal: any;

@Component({
  selector: 'app-edit-driver',
  templateUrl: './edit-driver.component.html',
  styleUrls: ['./edit-driver.component.css']
})
export class EditDriverComponent implements OnInit {

  driver: Driver;
  id: number;
  user: User;

  constructor(private dialogRef: MatDialogRef<EditDriverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private driverService: DriverService,
    private userService: UserService) { }

  ngOnInit() {
    this.id = this.data.id;
    if(this.id){
      console.log('hay data', this.data);
      this.userService.getUserInfo(this.data.uid).subscribe(result => {
        this.data.email = result.email;
        this.setDataForm(this.data);
      });
    }
    this.user = JSON.parse(sessionStorage.getItem('loggedUser'));
  }

  driverForm = new FormGroup({
    personalData: new FormGroup({
      documentNumber: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      birthDate: new FormControl('', Validators.required)
    }),
    contactData: new FormGroup({
      phone: new FormControl('', Validators.required),
      mobile: new FormControl(''),
      address: new FormControl('', Validators.required) 
    }),
    accountData: new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    })
  });

  setDataForm(data){
    this.driverForm.setValue({
      personalData: {
        documentNumber: data.documentNumber,
        name: data.name,
        lastName: data.lastName,
        birthDate: data.birthDate
      },
      contactData: {
        phone: data.phone,
        mobile: data.mobile,
        address: data.address
      },
      accountData: {
        email: data.email,
        password: ''
      }
    });
    this.driverForm.get('accountData.password').disable();
    this.driverForm.get('accountData.email').disable();
  }

  cancel(){
    this.dialogRef.close();
  }

  async saveDriver(){
    try {
      this.driver = {
        documentNumber: this.driverForm.value.personalData.documentNumber,
        name: this.driverForm.value.personalData.name,
        lastName: this.driverForm.value.personalData.lastName,
        birthDate: this.driverForm.value.personalData.birthDate,
        phone: this.driverForm.value.contactData.phone,
        mobile: this.driverForm.value.contactData.mobile,
        address: this.driverForm.value.contactData.address
      }
      this.driver.id = this.id;
      this.driver.enterprise = this.user.databaseId;
      if(this.driverForm.status === 'INVALID'){
        //mensaje de validacion
        this.openAlert(0);
      }else{
        await this.createDriverAccount()
      }
    } catch (error) {
      console.error(error)
    }
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }

  getDriverAccount(driver: Driver){
    console.log(this.driver);
  }

  async createDriverAccount(){
    let user: {email: string, password: string, role: Role} = {
      email: this.driverForm.value.accountData.email, 
      password: this.driverForm.value.accountData.password,
      role: "driver"
    }
    try {
      // console.log(user)
      let newUser: User = await this.userService.register(user.email, user.password, user.role);
      if(newUser){
        this.driver.user_uid = newUser.uid;
        this.driverService.saveDriver(this.driver).subscribe(driverSaved => {
          console.log('Driver saved!', driverSaved);
          let userToUpdate: User = newUser;
          userToUpdate.databaseId = this.user.databaseId;
          this.userService.updateUserData(userToUpdate);
          this.openAlert(1);
          this.dialogRef.close(driverSaved);
        })
      }
    } catch (error) {
      console.error('error al crear usuario -> ', error);
    }
  }

}
